




import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			showDashboardIframe: true,
		};
	},
	computed: {
		wmsDashboardUrl() {
			return `${this.dmsSys.DMSC_url}/wms/WmsDashboard`;
		},
	},
});
